import React from "react";
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import Layout from "../layouts/layout";
import PageHeading from "../layouts/pageHeading";
import Index from "../components/EligibilityCriteria";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link as MuiLink, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties";
import Cookies from "js-cookie";

export default function EligibilityManagement() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const naviagte = useNavigate();

  const handleClick = () => {
    if (page === "addeligibility" || page === "updateeligibility") {
      naviagte(`/${Cookies.get("mhet_mst_project")}/eligibility-management?page=eligibilitycriteria`);
    }
  };

  const breadcrumbs = [
    <MuiLink
      underline="hover"
      key="1"
      component={NavLink}
      to={`/${Cookies.get("mhet_mst_project")}/home`}
      sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Dashboard
    </MuiLink>,
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: page === "eligibilitycriteria"  ? "bold" : 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
        ":hover":{
          textDecoration: page === "eligibilitycriteria" ? "none" : "underline",
          cursor : page === "eligibilitycriteria" ? "none" : "pointer"
        }
      }}
      onClick={page === "eligibilitycriteria" ? undefined : handleClick}
    >
      Eligibility Criteria {page === "eligibilitycriteria" && <MdKeyboardArrowDown size={16} /> }
    </Typography>,
  ];

  if (page === "addeligibility") {
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Add Eligibility<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }else if (page === "updateeligibility"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Update Eligibility<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs}/>
      <Sidebar />
      <Layout>
        <PageHeading
          title={
            page === "eligibilitycriteria"
              ? "Eligibility Criteria"
              : page === "addeligibility"
              ? "Add Eligibility"
              : page === "updateeligibility"
              ? "Update Eligibility"
              : null
          }
        />
        <Index />
      </Layout>
    </>
  );
}
